import { projectToCRS } from "@nova/calculate-geospatial"
import { Coordinate3D } from "@nova/constants"
import { InfraredImage, OrthoImage } from "@nova/protobuf"
import { FeatureCollection } from "geojson"
export const flightpathTransformer = (
    uploadSets: (InfraredImage | OrthoImage)[][],
    projection?: string
) => {
    const json = {
        type: "FeatureCollection",
        features: uploadSets.map((uploads) => ({
            type: "Feature",
            geometry: {
                type: "LineString",
                coordinates: uploads.map((upload) =>
                    projectToCRS([upload.longitude, upload.latitude], projection)
                ),
            },
        })),
    } as FeatureCollection
    return json
}

export const liveVideoFlightPathTransformer = (flightPath: Coordinate3D[], projection?: string) => {
    const json = {
        type: "FeatureCollection",
        features: [
            {
                type: "Feature",
                geometry: {
                    type: "LineString",
                    coordinates: flightPath.map((fgrame) =>
                        projectToCRS([fgrame.longitude, fgrame.latitude], projection)
                    ),
                },
            },
        ],
    } as FeatureCollection
    return json
}
